export default __webpack_public_path__ + "static/media/avatar_mice10.e621b281.mp3";